// Sugalarm — small status dot in the kiosk header.

interface Props {
  status: "ok" | "stale" | "down";
}

export function ConnDot({ status }: Props) {
  const c =
    status === "ok"
      ? "var(--zone-ok)"
      : status === "stale"
        ? "var(--zone-warn)"
        : "var(--zone-urgent)";
  return (
    <span
      style={{
        width: 7,
        height: 7,
        borderRadius: 999,
        background: c,
        display: "inline-block",
      }}
    />
  );
}
